var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',{attrs:{"multiple":"","data-title":"Usuários","data-menu-heading":"Usuários","data-menu-width":"290px","data-button-gradient":true,"data-items":_vm.users},on:{"input":_vm.setOperationsFilter,"search":function($event){return _vm.searchIds($event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }